import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { FiShoppingCart, FiZap, FiCheck } from 'react-icons/fi';
import toast from 'react-hot-toast';
import './ProductCard.css';

const NPR = (amount) =>
  'NPR ' + parseFloat(amount || 0).toLocaleString('en-NP', { minimumFractionDigits: 0 });

const ProductCard = ({ product }) => {
  const { addItem } = useCart();
  const [adding, setAdding] = useState(false);

  const img = product.images?.find((i) => i.is_primary) || product.images?.[0];
  const outOfStock = product.inventory === 0;
  const lowStock = product.inventory > 0 && product.inventory < 5;

  const specs = [
    product.max_flight_time && { icon: '✈', text: product.max_flight_time },
    product.camera_sensor && { icon: '📷', text: product.camera_sensor },
  ].filter(Boolean);

  const handleAddToCart = async (e) => {
    // The whole card is a link — keep the button from navigating
    e.preventDefault();
    e.stopPropagation();
    if (outOfStock || adding) return;

    setAdding(true);
    try {
      await addItem(product, 1, product.price);
      toast.success(`${product.title} added to cart`);
    } catch {
      toast.error('Failed to add item');
    } finally {
      setAdding(false);
    }
  };

  return (
    <Link to={`/products/${product.slug}`} className="pc">
      <div className="pc-media">
        {img ? (
          <img src={img.image} alt={img.alt || product.title} className="pc-img" loading="lazy" />
        ) : (
          <div className="pc-img-fallback"><FiZap /></div>
        )}

        {outOfStock && <span className="pc-flag pc-flag-out">Out of stock</span>}
        {lowStock && <span className="pc-flag pc-flag-low">Only {product.inventory} left</span>}

        <button
          className="pc-add"
          onClick={handleAddToCart}
          disabled={outOfStock || adding}
          title={outOfStock ? 'Out of stock' : 'Add to cart'}
          aria-label={outOfStock ? 'Out of stock' : `Add ${product.title} to cart`}
        >
          {adding ? <FiCheck /> : <FiShoppingCart />}
          <span>{outOfStock ? 'Unavailable' : 'Add to cart'}</span>
        </button>
      </div>

      <div className="pc-body">
        {product.category && <span className="pc-cat">{product.category}</span>}
        <h3 className="pc-title">{product.title}</h3>

        {specs.length > 0 && (
          <div className="pc-specs">
            {specs.map((s) => (
              <span key={s.text}>{s.icon} {s.text}</span>
            ))}
          </div>
        )}

        <div className="pc-foot">
          <span className="pc-price">{NPR(product.price)}</span>
          {!outOfStock && <span className="pc-stock">In stock</span>}
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
